export const SAVE_PRODUCTS = "SAVE_PRODUCTS";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const RESTORE_PRODUCTS_FROM_LOCALSTORAGE =
  "RESTORE_PRODUCTS_FROM_LOCALSTORAGE";
